import {
  removeDuplicates,
  formatDateTime,
  generateDateTimeString,
  deepEqual,
  formatNumber,
  formatCurrency,
  formatPrice,
} from "./utils";

export default {
  install(Vue) {
    Vue.prototype.$utils = {
      removeDuplicates,
      formatDateTime,
      generateDateTimeString,
      deepEqual,
      formatNumber,
      formatCurrency,
      formatPrice,
    };
  },
};
